export default __webpack_public_path__ + "static/media/css.5bd8c816.png";